import axiosInstance, { axiosPublic } from './axiosInstance';

/** 로그인한 사용자의 프로필. 401은 axiosInstance 인터셉터가 재발급/로그아웃으로 처리한다. */
export async function getMyProfile() {
  const response = await axiosInstance.get('/v1/users/me/profile');
  return response.data?.data ?? response.data;
}

export async function createUser({ email, password, verificationToken, phoneNumber, agreements }) {
  const body = { email, password, verificationToken, agreements };
  if (phoneNumber) body.phoneNumber = phoneNumber;
  const response = await axiosPublic.post('/v1/users/signup', body);
  return response.data?.data ?? response.data;
}
